/**
 * App-wide shared table pagination defaults (used across ~55 tables, e.g.
 * ExpenseManagement/ExpenseDashboard.js and EmpInfoManagement/Overview).
 *
 * Kept in one place so every list in the app offers the same page-size
 * choices — previously each table hardcoded its own (10, 20, 25, 100 or none).
 * Ant Design expects pageSizeOptions as strings.
 */
export const PAGE_SIZE_OPTIONS = ["10", "20", "25", "50", "100"];

export const DEFAULT_PAGE_SIZE = 25;

/**
 * Spread into a Table's `pagination` prop for client-side paged tables:
 *   pagination={{ ...TABLE_PAGINATION }}
 * Server-paged tables should spread this and then override current/pageSize/total
 * from their own state.
 */
export const TABLE_PAGINATION = {
  showSizeChanger: true,
  defaultPageSize: DEFAULT_PAGE_SIZE,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
  // Antd auto-shrinks pagination to its borderless "small" look whenever the
  // Table itself is size="small"/"middle" (see antd's Table.js: paginationSize
  // falls back to 'small' for either). Pin it to 'default' so pagination looks
  // the same everywhere regardless of the table's own row density.
  size: "default",
};
